export default __webpack_public_path__ + "static/Metal_Trapdoor-e6cd856835ac7007058f8484486e9b1c.png";